import { render } from "./Special-index.vue?vue&type=template&id=04cb458c&scoped=true"
import script from "./Special-index.vue?vue&type=script&lang=js"
export * from "./Special-index.vue?vue&type=script&lang=js"

import "./Special-index.vue?vue&type=style&index=0&id=04cb458c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04cb458c"]])

export default __exports__